import { Exclude, Expose, Transform } from 'class-transformer';

/**
 * A trait.
 */
@Exclude()
export class Trait {
  /**
   * The trait id.
   */
  @Expose()
  id: string;

  /**
   * The trait name.
   */
  @Expose()
  name: string;

  /**
   * The trait value.
   */
  @Expose()
  @Transform((value) => (value === null || value === '' ? '—' : value))
  value: string;

  /**
   * The trait accuracy.
   */
  @Expose()
  @Transform((value) => (value === null ? '' : value))
  accuracy: string;

  /**
   * The trait percentile.
   */
  @Expose()
  percentile: number;

  /**
   * The trait leader flag.
   */
  @Expose()
  hasLeader: boolean;

  /**
   * The trait accuracy type.
   */
  @Expose()
  accuracyType: number;

  /**
   * The trait accuracy flag.
   */
  @Expose()
  hasAccuracy: boolean;

  /**
   * The RBV flag.
   */
  @Expose()
  isRbv: boolean;

  /**
   * Full trait name.
   */
  @Expose()
  label: string;

  /**
   * Unit of measure, eg: `%`.
   */
  @Expose({ name: 'units' })
  uom: string;
}
